import { useState } from "react";
import { Button } from "../ui/button";
import { Shield, Menu, X, RefreshCw, Unlock } from "lucide-react";

export function AdminShell({ nav, section, onSelect, title, onRefresh, loading, onLogout, children }) {
  const [open, setOpen] = useState(false);
  const Nav = (
    <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
      {nav.map(n => {
        const Icon = n.icon;
        const active = section === n.id;
        return (
          <button key={n.id} data-testid={`admin-nav-${n.id}`} onClick={() => { onSelect(n.id); setOpen(false); }}
            className={`relative w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${active ? "bg-indigo-50 text-indigo-700" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"}`}>
            {active && <span className="absolute left-0 top-2 bottom-2 w-1 rounded-full bg-indigo-600" />}
            <Icon className="w-4.5 h-4.5 w-[18px] h-[18px]" />
            <span className="flex-1 text-left">{n.label}</span>
            {n.count > 0 && <span className="text-[11px] font-semibold bg-indigo-600 text-white rounded-full px-1.5 min-w-[20px] text-center" data-testid={`admin-nav-count-${n.id}`}>{n.count}</span>}
          </button>
        );
      })}
    </nav>
  );
  const Brand = (
    <div className="h-16 px-5 flex items-center gap-3 border-b border-slate-100">
      <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-600 to-violet-600 flex items-center justify-center"><Shield className="w-5 h-5 text-white" /></div>
      <div><p className="font-bold text-slate-900 leading-tight">WebGenerator</p><p className="text-[11px] text-slate-500">Admin-Bereich</p></div>
    </div>
  );
  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="admin-shell">
      <aside className="hidden lg:flex w-64 flex-shrink-0 bg-white border-r border-slate-200 flex-col sticky top-0 h-screen" data-testid="admin-sidebar">{Brand}{Nav}</aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-40 flex">
          <div className="w-64 bg-white flex flex-col shadow-xl">{Brand}{Nav}</div>
          <div className="flex-1 bg-slate-900/40" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="h-16 bg-white/90 backdrop-blur border-b border-slate-200 px-4 sm:px-6 flex items-center justify-between sticky top-0 z-30">
          <div className="flex items-center gap-3">
            <button className="lg:hidden p-2 -ml-2" onClick={() => setOpen(o => !o)} data-testid="admin-mobile-menu-btn" aria-label="Menü">{open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}</button>
            <h1 className="text-lg sm:text-xl font-bold tracking-tight text-slate-900" data-testid="admin-section-title">{title}</h1>
          </div>
          <div className="flex items-center gap-2">
            <Button data-testid="refresh-btn" size="sm" variant="outline" onClick={onRefresh} disabled={loading} className="rounded-lg"><RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} /></Button>
            <Button data-testid="admin-logout-btn" size="sm" variant="ghost" onClick={onLogout}><Unlock className="w-4 h-4 mr-1" /> Abmelden</Button>
          </div>
        </header>
        <main className="p-4 sm:p-6 lg:p-8 max-w-6xl w-full" data-testid="admin-main">{children}</main>
      </div>
    </div>
  );
}
